import styled from 'styled-components';

export const ScBonusCardTimer = styled.div<{ $isUrgent?: boolean }>`
  font-size: 12px;
  line-height: 18px;
  width: 100%;
  color: ${({ $isUrgent, theme }) => ($isUrgent ? theme.yellowColor : 'inherit')};
`;
